import { useMemo } from "react";

export const useSortedItems = (items, providedDataKeys, orderIndexFound) => {
  let sortingItemConfig = {};

  if (providedDataKeys) {
    sortingItemConfig = {
      key: providedDataKeys[orderIndexFound],
      direction: "descending",
    };
  }

  const sortedItems = useMemo(() => {
    if (sortingItemConfig && sortingItemConfig.key) {
      let sortableItems = [...items];
      if (sortingItemConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a.campaign[sortingItemConfig.key] < b.campaign[sortingItemConfig.key]) {
            return sortingItemConfig.direction === "ascending" ? -1 : 1;
          }
          if (a.campaign[sortingItemConfig.key] > b.campaign[sortingItemConfig.key]) {
            return sortingItemConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }
  }, [items, sortingItemConfig]);

  const sortItemsBy = (key) => {
    let direction = "ascending";
    if (
      sortingItemConfig &&
      sortingItemConfig.key === key &&
      sortingItemConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    sortingItemConfig = { key, direction };
  };
  return { items: sortedItems, sortItemsBy, sortingItemConfig };
};

export const sortByCreatedAtDescending = (a, b) => {
  if (!a || !b) return 0;
  return new Date(b.createdAt) - new Date(a.createdAt);
};
